import { Button } from 'antd';
import styled from 'styled-components';

export const ButtonResendStyled = styled(Button)`
    display: flex;
    align-items: center;
    justify-content: center;
`;
